import { veeFormFieldHOC } from '@/kasten-components/components/KaVeeFormField';

import { default as KaCheckboxButtonGroup } from './KaCheckboxButtonGroup.vue';

export type {
  KaCheckboxButtonGroupOption,
  KaCheckboxButtonGroupProps,
  KaCheckboxButtonGroupValue,
} from './types';

export const KaCheckboxButtonGroupVee = veeFormFieldHOC(KaCheckboxButtonGroup);

export { KaCheckboxButtonGroup };
